import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { isFiscalComplete } from "@/components/FiscalDataSection";

export function FiscalReminder() {
  const { user } = useAuth();
  if (!user || isFiscalComplete(user)) return null;
  return (
    <div data-testid="fiscal-reminder" className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3 justify-between border border-amber-300 border-l-4 border-l-amber-500 bg-amber-50 p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <div className="font-bold text-sm text-amber-900">Completa tus datos fiscales para poder facturar</div>
          <p className="text-xs text-amber-800 mt-0.5">NIF, dirección fiscal, código postal, ciudad y provincia son obligatorios para emitir facturas legales.</p>
        </div>
      </div>
      <Link to="/profile#fiscal" data-testid="fiscal-reminder-cta" className="h-10 px-4 bg-slate-900 text-white text-sm font-bold inline-flex items-center gap-2 hover:bg-slate-800 transition-colors shrink-0">
        Completar ahora <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
